module.exports = __webpack_public_path__ + "img/noData.bf9088a7.png";